import { createContext, useContext, useEffect, useState } from 'react';
import { randomNumber } from '../lib/constants';

const NotificationContext = createContext<Toaster | undefined>(undefined);

export const NotificationProvider = (props: NotificationProviderProps) => {
  const { children, count = 5, delay = 5000 } = props;
  const [defaultDelay, setDefaultDelay] = useState(delay);
  const [queue, setQueue] = useState<ToastNotification[]>([]);
  const [dismissTimer, setDismissTimer] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (queue.length > count) {
      setQueue(queue.slice(queue.length - count));
    }
    if (queue.length === 0 && dismissTimer) {
      clearInterval(dismissTimer);
      setDismissTimer(null);
    }
    if (queue.length > 0 && !dismissTimer) {
      const currentToast = queue[0];
      if (!currentToast.disableDelay)
        setDismissTimer(
          setInterval(() => setQueue((queue) => queue.slice(1)), defaultDelay)
        );
    }
  }, [queue.length]);

  function addNotification(notification: CreateToastNotification) {
    if (notification)
      setQueue([
        ...queue,
        Object.assign({}, notification, { id: randomNumber() }),
      ]);
  }

  function dismissNotification(id: number) {
    if (id) setQueue(queue.filter((m) => m.id !== id));
  }

  const toaster = {
    notifications: queue,
    addNotification: addNotification,
    dismissNotification: dismissNotification,
  };

  return (
    <NotificationContext.Provider value={toaster}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);

  if (context === undefined)
    throw new Error(
      'useNotification must be used within an NotificationProvider'
    );

  return context;
};
